import { Box, Grid, Stack, useMediaQuery, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import FounderDetails from "./founderDetails";
import companyData from '../../../assets/data/company.json';

const FoundersLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('about.founders.title')}
                        description={t('about.founders.description')}
                    />

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        container
                        width='100%'
                        spacing={{xs: 2, md: 10}}
                        className="hideScrollBar"
                        sx={{
                            overflowX: 'hidden'
                        }}
                    >
                        <Grid 
                            size={{xs: 12, md: 4}} 
                            data-aos={!isMobile ? "fade-right" : "fade-up"}
                        >
                            <FounderDetails 
                                name={t('about.founders.prasanth.name')}
                                image={companyData.founders.prasanth.image}
                                role={t('about.founders.prasanth.role')}
                                linkedIn={companyData.founders.prasanth.linkedIn}
                                note={t('about.founders.prasanth.note')}
                            />
                        </Grid>

                        <Grid 
                            size={{xs: 12, md: 4}}
                            data-aos="fade-up"
                        >
                            <FounderDetails 
                                name={t('about.founders.ram.name')}
                                image={companyData.founders.ram.image}
                                role={t('about.founders.ram.role')}
                                linkedIn={companyData.founders.ram.linkedIn}
                                note={t('about.founders.ram.note')}
                                backgroundLayerPosition={{
                                    right: 0
                                }}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default FoundersLayout;